// extracted by mini-css-extract-plugin
export var modal = "_dt-0";